;(function($) {
  var updateProfile = function (button, popin, data, onSuccess, state) {
    var csrfConfig = Storage.getData('csrf_config');
    button.buttonLoading('loading');

    data[csrfConfig['token_name_key']] = popin.attr('data-csrf-name');
    data[csrfConfig['token_key']]      = popin.attr('data-csrf-token');

    $.post('/admin/user-profile/{0}'.format(popin.attr('data-user-id')), data)
      .done(function() {
        popin.find('.alert-danger').addClass('hidden');
        onSuccess();
      })
      .fail(function (response) {
        if (403 === response.status) {
          window.location.href = '/admin/login';

          return false;
        }
        var
          message = undefined === response.responseJSON.error ? 'Undefined error' : response.responseJSON.error,
          error   = popin.find('.alert-danger');

        error.removeClass('hidden');
        error.text(message);
      })
      .always(function (data, textStatus, jqXHR) {
        button.buttonLoading('reset');

        if (undefined !== state && 'success' === textStatus) {
          button.button(state)
        }
      })
    ;
  };

  var showUserPopin = function (data) {  
    $.fancybox.open({
      content: data.popin,
      padding: 0,
      type: 'iframe',
      afterShow: function () {

          var userIsActive = $('#userStatusToggle').is(':checked');
          $('#userStatusLabel').css('color', userIsActive ? '#5cb85c' : '#d9534f');
          $('#userStatusToggle').on('change', function() {
              var userIsActive = $(this).is(':checked');
              var label = $('#userStatusLabel');
              if (userIsActive) {
                  label.text('פעיל').css('color', '#5cb85c');
              } else {
                  label.text('לא פעיל').css('color', '#d9534f');
              }
                          
          });
        
        $('#admin-user-popin button.close-window').click(function() {
          $.fancybox.close();
        });

        $('#admin-user-popin .admin-disable-tfa-button').click(function(e) {
          e.preventDefault();

          var
            popin  = $('#admin-user-popin'),
            button = $(this)
          ;

          updateProfile(button, popin, {'tfa': false}, function () {
            popin.find('.admin-disable-tfa-disabled-text').removeClass('hidden');
            popin.find('.admin-disable-tfa-enabled-text').addClass('hidden');
            popin.find('.admin-tfa-reminder-button').removeClass('hidden');
            popin.find('.admin-tfa-reminder-text').addClass('hidden');
            button.parent().remove();
          });
        });

        $('#admin-user-popin .admin-tfa-reminder-button').click(function (e) {
          e.preventDefault();

          var
            button = $(this),
            popin  = $('#admin-user-popin'),
            state  = 'enabled' === button.attr('data-state') ? 'disabled' : 'enabled',
            enabled = 'enabled' === state
          ;

          updateProfile(button, popin, {'tfaReminder': enabled}, function () {
            button.attr('data-state', state);
          }, state);
        });

        $('#admin-user-popin .admin-verify-phone-button').click(function (e) {
          var
            button = $(this),
            popin  = $('#admin-user-popin'),
            phone  = { code: button.attr('data-phone-code'), number: button.attr('data-phone-number') }
          ;

          updateProfile(button, popin, {phone: phone}, function () {
            button.remove();
            popin.find('.admin-verify-phone-text').removeClass('hidden');
          });
        });

        $('#admin-user-form-submit').click(function (e) {
          e.preventDefault();

          $(this).button('loading');

          var
            button = $(this),
            popin  = $('#admin-user-popin'),
            email = $('#admin-user-email-address-input').val(),
            userStatus = $('#userStatusToggle').is(':checked') ? 1 : 0,
            errors = '',
            re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ;

          if (!re.test(email) || email === '') {
            errors += $.translate('Email is invalid') + '\n';
          }

          if (errors !== '') {
            $('#admin-user-form-errors').html(nl2br(errors, true)).removeClass('hidden');
            $('#admin-user-form-submit').button('reset');

            return false;
          } else {
            $('#update-settings-errors').addClass('hidden');
            $('#admin-user-form-errors').html('');

            updateProfile(button, popin, {'email': email, 'userStatus': userStatus, }, function () {
              $('#admin-user-form-submit').button('reset');
              $.fancybox.close();
            });
          }
        });
      }
    });
  };

  $(document).ready(function() {
    $('.admin-user-settings-popin').click(function (e) {

      e.preventDefault();

      var button = $(this);

      button.buttonLoading('loading');

      $.get('/admin/user/{0}'.format(button.attr('data-user-id')))
        .done(function (response) {
          showUserPopin(response)
        })
        .fail(function (response) {
          if (403 === response.status) {
            window.location.href = '/admin/login';
          }
        })
        .always(function () {
          button.buttonLoading('reset')
        })
      ;
    });
  });
})(jQuery);
